/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../membershipManager.module.ts" />

module Meevo.Plugins.MembershipManager {
    'use strict';
    import IDataMaintenanceSection = Meevo.Components.BaseClasses.IDataMaintenanceSection;
    import DataMaintenanceSectionBase = Meevo.Components.BaseClasses.DataMaintenanceSectionBase;

    export interface IMembershipBaseSection extends IDataMaintenanceSection<Model.ClientMembership>, Model.ClientMembership {
        setMembershipShortcut(): void,
        setDisplayName(): void,
        loadDependentData(): ng.IPromise<any>,
        validateCanEdit(): boolean,
        autoRenewSettings?: any,
    }

    export interface IMembershipManagerSectionParams extends Meevo.Model.ISectionParamsClientMembership, IMembershipManagerSearchContext {
        securityChecker?: Meevo.Components.Common.ISecurityService,
        $rootScope?: angular.IRootScopeService,
        $filter?: angular.IFilterService;
    }

    export class MembershipBaseSection extends DataMaintenanceSectionBase<Model.ClientMembership>  implements  IMembershipBaseSection {
        public clientMembershipList = [];
        public disableCrud: boolean = false;
        public isTaxExempt: boolean = false;

        constructor(protected params: IMembershipManagerSectionParams) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void {}

        public sectionModelRetrieved(): void {
            this.params.busyService.start();
            if (angular.isUndefined(this.model && this.model.id)) {
                this.model.id = this.params.clientMembership.id;
            }
            this.setDisplayName();

            this.params.$q.all([this.loadClientMembershipList(), this.loadDependentData()])
                .finally(() => {
                    this.params.busyService.stop();
                });
        }

        /**
         * Load additional data for every section. Redefine if needed
         * */
        public loadDependentData(): ng.IPromise<any> {
            let deferred = this.params.$q.defer();

            deferred.resolve();
            return deferred.promise;
        }


        /**
         * Get list of client memberships from server
         * */
        private loadClientMembershipList(): ng.IPromise<any> {
            return this.dataService.getListPaged(this.baseEndpoint, {
                criteria: {
                    clientId: this.params.clientMembership.clientId,
                    includePrevious: true
                }
            })
                .then(data => {
                    this.clientMembershipList = data;
                    this.setMembershipShortcut();

                    return data;
                });
        }

        /**
         * Assign to the model the shortcut of selected membership
         * */
        public setMembershipShortcut(): void {
            this.model.membershipShortcut = _.findWhere(this.clientMembershipList, {'id': this.model.id}).shortcut;
        }

        /**
         * Set section display name
         * */
        public setDisplayName(): void {
            let _membership = _.findWhere(this.clientMembershipList, {'id': this.model.id});

            if (_membership) {
                this.model.displayName = `${_membership.lastName}, ${_membership.firstName} `;
                if (!device.mobile()) {
                    this.model.displayName += `${ _membership.membershipNumber}`
                }
            } else {
                let obj = this.params.clientMembership;
                this.model.displayName = `${obj.lastName}, ${obj.firstName} `;
                if (!device.mobile()) {
                    this.model.displayName += `${ obj.membershipNumber}`
                }
            }
        }

        /**
         * Go to Client tab
         * */
        public headerContentAction = ($event: any): void => {
            let clientId = _.findWhere(this.clientMembershipList, { 'id': this.model.id }).clientId,
                stateParams = {
                    id: clientId,
                    actionState: Model.MaintenanceFormState.Readonly,
                    targetState: Model.MaintenanceFormVisualState.Detail
                };

            this.params.$rootScope.$broadcast("gotoState", {
                stateName: this.appSettings.ROUTE_NAMES.client,
                stateParams: stateParams
            });
            $event.stopPropagation();
        }

        /**
        * Validate canEdit for help context function
        * */
        public validateCanEdit(): boolean {
            return this.model.clientMembershipStatusEnum !== Model.ClientMembershipStatusEnum.Cancelled &&
                this.model.clientMembershipIndicatorStatus !== Model.ClientMembershipIndicatorStatusEnum.Frozen;
        }
    }
}
